import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAllDataLabelVisibilityCheckbox, createChartColumnNumberFormatter, createColumnNameTextInput, createDataLabelVisibilityCheckbox, createGradientColorPicker, createMapTileTypeDropdown, createMaxDataPointsInput, createTooltipContentFormatter, createTooltipVisibilityCheckbox, } from '../schema-composer-utils/common-elements';
import { shouldHideDataLabelsAccordion } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createGradientColorPicker(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
];
const displaySettings = [
    createSection({
        children: [createMaxDataPointsInput(), createMapTileTypeDropdown()],
    }),
];
const dataLabelSettings = [
    createSection({
        children: [createAllDataLabelVisibilityCheckbox()],
        isChartProperty: true,
    }),
    createSection({
        isHiddenCallback: shouldHideDataLabelsAccordion,
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        key: 'columnName',
                        isAnswerProperty: true,
                        runTimeProperties: {
                            header: 'TS_INPUT',
                        },
                        children: [createDataLabelVisibilityCheckbox()],
                    }),
                ],
            }),
        ],
    }),
];
export const geoHeatmapChartSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
    [ChartSettingsV2MenuItems.AXIS]: null,
    [ChartSettingsV2MenuItems.DATA_LABEL]: dataLabelSettings,
    [ChartSettingsV2MenuItems.LEGEND]: null,
};
//# sourceMappingURL=geo-heatmap-schema.js.map